import { User } from '../../store/user/types'
import { callApi } from '../../utils/api'
import { endpoints } from '../config'

export const fetchUserData = async (token: string): Promise<User | null> => {
  const response = await callApi<User>({
    path: endpoints.getUser,
    token
  })

  if (!response.isOk || !response.data) {
    return null
  }

  return response.data
}
